import { useState } from 'react';

export interface NotificationData {
  isOpen: boolean;
  type: 'success' | 'error' | 'warning' | 'info';
  title: string;
  message: string;
  details?: string;
}

export const useNotification = () => {
  const [notification, setNotification] = useState<NotificationData>({
    isOpen: false,
    type: 'info',
    title: '',
    message: '',
    details: ''
  });

  const showNotification = (
    type: 'success' | 'error' | 'warning' | 'info',
    title: string,
    message: string,
    details?: string
  ) => {
    setNotification({
      isOpen: true,
      type,
      title,
      message,
      details
    });
  };

  const hideNotification = () => {
    setNotification(prev => ({
      ...prev,
      isOpen: false
    }));
  };

  const showSuccess = (title: string, message: string, details?: string) => {
    showNotification('success', title, message, details);
  };

  const showError = (title: string, message: string, details?: string) => {
    showNotification('error', title, message, details);
  };

  const showWarning = (title: string, message: string, details?: string) => {
    showNotification('warning', title, message, details);
  };

  const showInfo = (title: string, message: string, details?: string) => {
    showNotification('info', title, message, details);
  };

  return {
    notification,
    showNotification,
    hideNotification,
    showSuccess,
    showError,
    showWarning,
    showInfo
  };
};
